import "../../../chunk-5WRI5ZAA.js";

// src/visualBuilder/utils/types/index.types.ts
var FieldDataType = /* @__PURE__ */ ((FieldDataType2) => {
  FieldDataType2["CUSTOM_FIELD"] = "custom_field";
  FieldDataType2["MULTILINE"] = "multiline";
  FieldDataType2["HTML_RTE"] = "html_rte";
  FieldDataType2["MARKDOWN_RTE"] = "markdown_rte";
  FieldDataType2["SELECT"] = "select";
  FieldDataType2["URL"] = "url";
  FieldDataType2["SINGLELINE"] = "singleline";
  FieldDataType2["JSON_RTE"] = "json_rte";
  FieldDataType2["MODULAR_BLOCK"] = "modular_block";
  FieldDataType2["LINK"] = "link";
  FieldDataType2["ISODATE"] = "isodate";
  FieldDataType2["BOOLEAN"] = "boolean";
  FieldDataType2["BLOCK"] = "block";
  FieldDataType2["NUMBER"] = "number";
  FieldDataType2["REFERENCE"] = "reference";
  FieldDataType2["GROUP"] = "group";
  FieldDataType2["EXPERIENCE_CONTAINER"] = "experience_container";
  FieldDataType2["FILE"] = "file";
  FieldDataType2["GLOBAL_FIELD"] = "global_field";
  FieldDataType2["TAXONOMY"] = "taxonomy";
  return FieldDataType2;
})(FieldDataType || {});
export {
  FieldDataType
};
//# sourceMappingURL=index.types.js.map